module.exports = __webpack_public_path__ + "media/intro-1.11f77b19.mp3";